import {fetchFileTypeLabelByItem, fetchFileTypeIcon, fetchItemById, fmtFileFullName} from "../../utils/resUtil";
import {fmtInvalidFileName, formatFileSize, validateFileName} from "../../../../common-components/src/utils/fileUtil";
import {formatStrDotyyyyMMddhhmm} from "../../../../common-components/src/utils/dateUtil";
import ucAvatar from "../../../../common-components/src/components/CustomAvator/avatar-index";
import ResourceMove from "./ResourceMove";
import ResourceEmpty from "./ResourceEmpty";
import ResourceSelect from "./ResourceSelect.vue";

const TABLE_OFFSET_TOP = 168;
const TABLE_MIN_HEIGHT = 150;
export default {
  name: "ResourceTable",
  components: {
    ucAvatar, ResourceMove, ResourceEmpty,
    ResourceSelect
  },
  props: {
    categoryType: Number,
    parentId: Number,
    fileData: Array,
    queryParams: {
      type: Object,
      default: {}
    },
    // 回收站标识
    recycleType: {
      type: Boolean,
      default: false
    }
  },
  filters: {},
  computed: {
    thNameHeaderComp() {
      let thName = '文件名称'
      try {
        const cnt = this.multipleSelection.length;
        return cnt > 0 ? '已选中' + cnt + '个文件/文件夹' : '文件名称'
      } catch (e) {
        console.error(e)
      }
      return thName;
    }
  },
  watch: {
    fileData: function () {
      this.$nextTick(function () {
        // console.log("watch fileData")
        this.resizeTableHeight();
      })

    }
  },
  data() {
    return {
      resourceContentVue: window.resourceContentVue,
      tableHeight: this.calcTableHeight(),
      editCellId: -1,
      editCellParentId: 0,
      editCellVal: '',
      editCellErrorTip: '', //文件名不能包含下列任何字符： / \\ ： * ？“ < > |',
      editCellFocus: false,
      editCellToolTipVisible: false,
      editCellToolTipTimer: 0,
      editCellRowItem: {id: 0, name: ''},
      editCellOldItem: {id: 0, name: ''},
      lastDeleteIds: [],

      currentRow: {},
      multipleSelection: [],
      multipleSelectionCache: {},
      notifyMsgCache: {},
      backOptDuration: 5000,

      addDirOptItem: {id: 0, st: 0},

      // last_modified_date/name/file_size/file_type
      sortColumnMap: {
        'name': 'name',
        'fileSize': 'file_size',
        'fileType': 'file_type',
        'lastModifiedDate': 'last_modified_date'
      },

      moveForm: {
        folderId: 0,
        id: 0,
        name: ''
      },
      fromPc: sessionStorage.getItem("fromPc")
    }
  },
  created() {
    window.resourceTableVue = this;

    this.$on('enterAddDir', (arg) => {
      this.enterAddDir(arg)
    })
  },
  mounted() {
    let _this = this;
    window.addEventListener('resize', () => {
      _this.resizeTableHeight();
    });
  },
  methods: {
    handleMouseDown() {
    },
    calcTableHeight() {
      if (this.fileData.length > 0) {
        let height = Math.max(window.innerHeight - TABLE_OFFSET_TOP, TABLE_MIN_HEIGHT);
        return height;
      } else {
        return 550;
      }
    },
    quitViewMode() {
      try {
        if (this.editCellId !== -1) {
          this.cancelEditMode()
        }
      } catch (e) {
        console.error(e)
      }
    },
    toggleViewMode(viewType, multipleSelectionIds) {
      if (viewType !== 'list') {
        return false;
      }
      this.resizeTableHeight()
      this.resetMultipleSelection(multipleSelectionIds)
      return true;
    },
    resetMultipleSelection(multipleSelectionIds) {
      try {
        let selectionData = [];
        let selectionCache = {};
        if (typeof (multipleSelectionIds) == "undefined") {
          multipleSelectionIds = []
        }
        // console.log('resetMultipleSelection',  multipleSelectionIds, new Date())
        this.fileData.forEach((row, index) => {
          if (multipleSelectionIds.indexOf(row.id) != -1 || multipleSelectionIds.indexOf('' + row.id) != -1) {
            selectionCache[row.id] = row
            selectionData.push(row)
            this.$refs.resTable.toggleRowSelection(this.fileData[index], true);
          } else {
            this.$refs.resTable.toggleRowSelection(this.fileData[index], false);
          }
        });
        this.multipleSelection = selectionData
        this.multipleSelectionCache = selectionCache
      } catch (e) {
        console.error(e)
      } finally {
        this.resetResEditModeType()
      }
    },
    resizeTableHeight() {
      this.tableHeight = this.calcTableHeight();
    },
    multipleMove() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.openResourceMoveDialog(ids);
    },
    openResourceMoveDialog(ids) {
      // console.log('openResourceMoveDialog', this.parentId, new Date())
      this.$refs.resourceMove.multipleMove(this.parentId, ids);
    },
    enterAddDir(parentId) {
      // console.log('table enterAddDir methods', parentId, new Date())
      if (this.editCellId !== -1) {
        let editCellItem = this.fetchFileItemById(this.editCellId);
        if (editCellItem != null) {
          this.changeResEditModeType(0)
          return;
        }
        this.afterAddDir();
      }
      this.ucloading.showLoading();
      let params = {parentId: parentId, name: '新建文件夹'};
      this.$api.post("/resapi/tw/resource-file/addDir", params).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // this.$message.success('创建文件夹成功');
        if (res.data) {
          let row = res.data;
          row.isNew = true;
          row.lastModifiedDate = new Date().getTime()
          this.fileData.unshift(row);
          this.enterEditNameMode(row, row.id, 0, true)
          // if(this.categoryType == 0) {this.rowDrop()}
        }
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
        this.afterAddDir();
      })
    },
    fetchFileItemById(id) {
      return fetchItemById(this.fileData, id);
    },
    switchResSortType(code, order) {
      let orderVal = (typeof (order) != "undefined" && order != null && order != '' ? order : 'ascending')
      this.$refs.resTable.sort(code, orderVal)
    },
    sortChange({prop, order}) {
      this.$emit('resetResSortType', prop, order)
      let orderField = (prop in this.sortColumnMap) ? this.sortColumnMap[prop] : prop;
      let orderType = order == null ? -1 : ((order == 'descending') ? 1 : 0);
      let params = {'orderField': orderField, 'orderType': orderType};
      this.refreshFiles(params)
    },
    refreshFiles(params) {
      this.afterAddDir()
      this.$emit('refreshFiles', params)
    },
    afterQueryFiles() {
      try {
        if(this.categoryType == 0) {
          this.rowDrop();
        }
      } catch (e) {
        console.error(e)
      }
    },
    // 行拖拽
    rowDrop() {
      if(this.recycleType) {
        return
      }
      const _this = this
      // 被拖动的元素的索引
      let dragged = null;
      // 被拖动的元素的索引
      let draggedIndex = -1;

      // 目标元素
      let target = document.querySelector('.el-table__body-wrapper tbody');
      let rows = 0;//行数
      setTimeout(function () {
        rows = target.childElementCount
        for (let i = 0; i < target.childElementCount; i++) {
          const child = target.children[i]
          child.draggable = true
          // child.style.cursor = 'copy'
          child.ondragstart = function (e) {
            let path;
            if (e.path){
              path = e.path;
            }else {
              path = e.composedPath();
            }
            for (let i in path){
              if (path[i].draggable){
                dragged = path[i];
              }
            }

            draggedIndex = dragged.rowIndex
            console.log('resTable  child' + i + '开始拖拽', e.target, new Date());
            _this.cellMouseIndex = -1
            dragged.style.cursor = 'grabbing'

            let dragingBox = document.getElementById("dragBox").cloneNode(true);
            dragingBox.style.display = "inline-block";
            dragingBox.id = "dragingBox";
            dragingBox.style.position = "absolute";
            dragingBox.style.top = "0px";
            dragingBox.style.right = "0px";
            dragingBox.style.zIndex = "-1";
            if (_this.multipleSelection.length > 1){
              dragingBox.innerHTML = "移动" + _this.multipleSelection.length + "文件到";
            }else {
              dragingBox.innerHTML = "移动到";
            }
            document.body.appendChild(dragingBox);
            e.dataTransfer.setDragImage(dragingBox, 0, 0);
          }
          child.ondragend = function () {
            console.log('child' + i + '拖拽结束', ' dragIndex=', dragIndex, new Date());
            document.body.removeChild(document.getElementById("dragingBox"));
            if(dragIndex  != -1) {
              const last = target.children[dragIndex];
              clearClass(last)
            }
          }
        }
      }, 0)

      // 被拖动的元素正在那个容器里
      let dragIndex = -1

      target.ondragenter = function (e) {
        clearTimeout(loop)
        let path;
        if (e.path){
          path = e.path;
        }else {
          path = e.composedPath();
        }
        // console.log('ondragenter', path[0], path.length, 'dragIndex=', dragIndex, new Date())
        // 由于被拖动的元素 经过tbody中的每一元素都会触发该事件, 但是我们只需要它正在那一行上就行了
        if (path[0].tagName === 'TD' || path.length > 1 && path[1].tagName == 'TD') {
          // throughRow 表示被拖动的元素正在哪一行上
          const throughRow = path.find(tmpPath => {
            if (typeof (tmpPath.className) != "undefined" && tmpPath.className != null) {
              if (tmpPath.className === 'el-table__row' || tmpPath.className.indexOf('el-table__row ') != -1) {
                return tmpPath
              }
            }
          })
          if (typeof (throughRow) != "undefined" && throughRow != null) {
            // console.log('ondragenter throughRow.rowIndex', throughRow, throughRow.rowIndex, 'dragIndex=', dragIndex, new Date())
            if (dragIndex !== throughRow.rowIndex) {
              if (dragIndex > -1) {
                // 清除上次进入的容器的状态
                const last = target.children[dragIndex];
                clearClass(last)
              }
              console.log('resTable 拖动进入目标元素 ' + throughRow.rowIndex);
              // 不是自己或为文件夹时才改变状态
              if (typeof(dragged) != "undefined" && dragged != null && draggedIndex !== throughRow.rowIndex && _this.fileData[throughRow.rowIndex].isDir == 1) {
                // 改变本次进入的容器的状态
                dragged.style.cursor = 'copy'
                throughRow.style.height = 60 + 'px'
                throughRow.style.backgroundColor = '#E6EDF5'
              }
              dragIndex = throughRow.rowIndex
            }
          }
        }
        leaveIndex = -1
      }

      target.ondragover = function (e) {
        console.log('resTable 目标元素中拖拽...');
        e.preventDefault();
        leaveIndex = -1
      }

      let loop = null
      let leaveIndex = -1 // 是否拖出了整个table, -1表示还在table内
      target.ondragleave = function (e) {
        let path;
        if (e.path){
          path = e.path;
        }else {
          path = e.composedPath();
        }
        clearTimeout(loop)
        // console.log('ondragleave', path[0], ', path.length=', path.length, 'dragIndex=', dragIndex, new Date())
        if (path[0].tagName === 'TD' || path.length > 1 && path[1].tagName == 'TD') {
          const throughRow = path.find(tmpPath => {
            if (typeof (tmpPath.className) != "undefined" && tmpPath.className != null) {
              if (tmpPath.className === 'el-table__row' || tmpPath.className.indexOf('el-table__row ') != -1) {
                return tmpPath
              }
            }
          })

          if (typeof (throughRow) != "undefined" && throughRow != null) {
            //if (dragIndex !== throughRow.rowIndex) {
              // console.log('拖动离开目标元素'+selectRow.rowIndex);
              // selectRow.style = {}
              // dragIndex = selectRow.rowIndex
            // }
            if ((throughRow.rowIndex === 0 || throughRow.rowIndex === rows - 1)) {
              // 离开第一行或最后一行
              leaveIndex = throughRow.rowIndex
              loop = setTimeout(function () {
                if (leaveIndex > -1) {
                  console.log("resTable 离开了", leaveIndex)
                  const leave = target.children[leaveIndex];
                  clearClass(leave)
                  dragIndex = -1
                }
              }, 100)
            }
          }
        } // end of if TD
      }
      target.ondrop = function () {
        console.log('resTable 放下了' + draggedIndex);
        // 清除上次进入的容器的状态
        const last = target.children[dragIndex];
        clearClass(last)
        dragged.style.cursor = 'default'
        const from = _this.fileData[draggedIndex]
        const to = _this.fileData[dragIndex]
        if (typeof (last) != "undefined" && last != null && (from.id != to.id) && (to.isDir == 1)) {
          // 移动文件/文件夹
          // console.log('resTable 放下了1'+draggedIndex, 'last', last, from, to, new Date());
          _this.copyOrMoveApi(from, to)
        }
      }

      let clearClass = function (node) {
        if (node) {
          node.style = {}
        }
        if (typeof (dragged) != "undefined" && dragged != null) {
          dragged.style.cursor = 'grabbing'
        }
      }

    },
    copyOrMoveApi(from, to) {
      let ids = [from.id];
      let selectIds = this.getMultipleSelectionIds()
      console.log('resTable copyOrMoveApi', from.id, to.id, 'selectIds', selectIds, selectIds.indexOf(from.id), new Date())
      if (selectIds.length > 0 && selectIds.indexOf(from.id) !== -1) {
        ids = selectIds
      }
      this.$refs.resourceMove.outerMoveCheck(to.id, ids);
    },
    uploadFiles(flag) {
      this.$emit('uploadFiles', flag)
    },
    download(ids, attachName) {
      this.$emit('download', ids, attachName)
    },
    multipleDownload() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.download(ids)
    },
    resetResEditModeType() {
      let type = 0;
      try {
        type = (this.multipleSelection.length > 1 ? 2 : (this.multipleSelection.length == 1 ? 1 : 0));
      } catch (e) {
        console.error(e)
      } finally {
        this.changeResEditModeType(type)
      }
    },
    changeResEditModeType(type) {
      this.$emit('changeResEditModeType', type)
    },
    gotoDir(row) {
      if (row.isDir == 1 || row.fileType == 999) {
        return this.refreshFiles({parentId: row.id, 'name': row.name, 'path': row.path})
      }
      if (this.fromPc && this.fromPc == 1) {
        this.pcDownload(row)
      } else {
        this.previewFile(row);
      }
    },
    // 去文件所在目录
    toDirectory(file) {
      this.$emit('toDirectory', file)
    },
    editName(id, name, row, index) {
      console.log('editName', id, name, row, index, new Date());
      let params = {id: id, name: name};
      this.$api.post("/resapi/tw/resource-file/editName", params).then(res => {
        if (res.success) {
          // console.log(res, this.editCellRowItem.id, this.editCellRowItem.name, name, index, new Date());
          this.editCellId = -1;
          if (this.editCellRowItem.id == id && this.editCellRowItem.name != name) {
            this.editCellRowItem.name = name
            const h = this.$createElement;
            const notifyId = 'notification-edit-back_' + new Date().getTime();
            const notity = this.$messageZ.success({
              title: '提示',
              message: h("p", null, [
                    h("span", null, '恭喜你，文件重命名成功'),
                    h("a", {
                      class: "notification-view-detail notification-edit-back",
                      on: {click: this.editNameBack}
                    }, "撤回"),
                  ]
              ),
              duration: this.backOptDuration
            });
            this.notifyMsgCache[notifyId] = notity;
            this.resetResEditModeType()
            this.refreshFiles()
          } else {
            if (typeof (row) != "undefined" && row.isNew) {
              row.isNew = false
              this.$message.success('创建文件夹成功');
              if(this.categoryType == 0) {this.rowDrop()}
              this.resetRowLastModifiedDate(row)
            }
            this.quitEditCellMode(index)
          }
        } else {
          this.$message.error(res.info);
          if (res.info == "文件名称重复") {
            this.editCellVal = this.editCellOldItem.name
          }
          this.forceFocusEditCell()
        }
      }).catch(error => {
        console.error(error);
        this.quitEditCellMode(index)
      })
    },
    closeAllNotify() {
      try {
        for (let notifyId in this.notifyMsgCache) {
          this.notifyMsgCache[notifyId].close();
        }
      } catch (e) {
        console.log(e, new Date())
      }
    },
    editNameBack() {
      let id = this.editCellOldItem.id;
      let name = this.editCellOldItem.name;
      // console.log('editNameBack',id, name, new Date())
      let params = {'id': id, 'name': name}
      this.closeAllNotify();
      this.$api.post("/resapi/tw/resource-file/editName", params).then(res => {
        try {
          if (res.success) {
            this.$message.success('撤回成功');
            if (this.editCellRowItem.id == id && this.editCellRowItem.name != name) {
              this.editCellRowItem.name = name
            }
            this.refreshFiles();
          } else {
            this.$message.error(res.info);
            this.refreshFiles();
          }
        } catch (t) {
          console.error(t, new Date())
        }
      })
    },
    multipleDelete() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.confirmDel(ids)
    },
    confirmDel(ids) {
      this.$confirm("确定要删除文件/文件夹？", "确认删除").then(() => {
        // console.log('confirmDel', ids, new Date());
        this.deleteFiles(ids)
      });
    },
    deleteFiles(ids) {
      if (typeof (ids) == "undefined" || ids == null || ids.length == 0) {
        return;
      }
      this.ucloading.showLoading();
      this.lastDeleteIds = ids;
      let params = {ids: ids.join(',')};
      this.$api.post("/resapi/tw/resource-file/deleteFiles", params).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          this.refreshFiles();
          return;
        }
        const delCnt = typeof (res.data) != "undefined" ? res.data : 0;
        const msgTxt = delCnt > 1 ? '恭喜你，' + delCnt + '个文件删除成功' : '恭喜你，文件删除成功'
        const h = this.$createElement;
        const notifyId = 'notification-delete-back_' + new Date().getTime();
        let notify = this.$messageZ.success({
          title: '提示',
          message: h("p", null, [
                h("span", null, msgTxt),
                h("a", {class: "notification-view-detail notification-edit-back", on: {click: this.deleteBack}}, "撤回删除"),
              ]
          ),
          duration: this.backOptDuration,
        });
        this.notifyMsgCache[notifyId] = notify;
        this.refreshFiles();
      }).finally(() => {
        this.ucloading.hideLoading();
      })
    },
    deleteBack() {
      let ids = this.lastDeleteIds || [];
      if (typeof (ids) == "undefined" || ids == null || ids.length == 0) {
        return;
      }
      this.closeAllNotify()
      this.ucloading.showLoading();
      let params = {ids: ids.join(',')};
      this.$api.post("/resapi/tw/resource-file/deleteBack", params).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          this.refreshFiles();
          return;
        }
        // console.log(res, new Date());
        this.$message.success('撤回成功');
        this.refreshFiles();
      }).finally(() => {
        this.ucloading.hideLoading();
      })
    },
    clickOptFileItem(code, row, index) {
      let editCellId = -1;
      if (code == 1) {
        // console.log('下载', row, index, new Date());
        this.download([row.id], row.isDir ? row.name + '.zip' : fmtFileFullName(row))
      } else if (code == 2) {
        // console.log('移动到', row, new Date());
        this.openResourceMoveDialog([row.id])
      } else if (code == 3) {
        // console.log('重命名', row,  index, new Date());
        editCellId = this.fetchRowKey(row, index);
      } else if (code == 4) {
        // console.log('删除', row, new Date());
        this.confirmDel([row.id])
      } else if (code === '5') {
        // console.log('还原', row, new Date());
        this.restoreFile(row.fileId)
      } else if(code === '6') {
        // console.log('永久删除', row, new Date());
        this.completeDelete(row.fileId)
      }
      this.enterEditNameMode(row, editCellId, index, false);
    },
    // '全部还原'按钮
    multipleReduction() {
      let ids = this.getMultipleSelectionIds()
      this.$emit('restoreFile', ids.join(','))
    },
    // '全部删除'按钮
    multipleDeleteRecycle() {
      let ids = this.getMultipleSelectionIds()
      this.completeDelete(ids.join(','))
    },
    // 回收站文件还原
    restoreFile(ids) {
      this.$emit('restoreFile', ids)
    },
    // 永久删除回收站文件
    completeDelete(ids) {
      this.$confirm('文件删除后将无法恢复，您确认要彻底删除所选文件吗？', '永久删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$emit('completeDelete', ids)
      })
    },
    enterEditNameMode(row, editCellId, index, forAddDir) {
      this.editCellId = editCellId;
      if (editCellId != -1) {
        // console.log('enterEditNameMode', row, editCellId, index, this.fromPc, new Date())
        this.editCellRowItem = row;
        this.editCellVal = row.name;
        this.editCellOldItem = {id: row.id, name: row.name}
        this.delayFocusEditCell(editCellId, forAddDir)
        this.closeAllNotify()
        this.changeResEditModeType(1)
        this.resetTrDraggable(index, false)
      } else {
        this.resetTrDraggable(index, true)
      }
    },
    resetTrDraggable(index, draggable) {
      try {
        if (typeof (index) == "undefined" || index < 0) {
          return;
        }
        let tbody = document.querySelector('.el-table__body-wrapper tbody')
        if (typeof (tbody) != "undefined" && tbody.childElementCount > 0 && index < tbody.childElementCount) {
          // console.log('resetTrDraggable', index, tbody.childElementCount, draggable,  new Date())
          tbody.children[index].draggable = draggable
        }
      } catch (e) {
        console.error(e)
      }
    },
    delayFocusEditCell(editCellId, forAddDir) {
      if (typeof (editCellId) == "undefined" || editCellId == null) {
        editCellId = this.editCellId
      }
      if (typeof (forAddDir) == "undefined" || forAddDir == null) {
        forAddDir = false
      }
      if (editCellId == -1) {
        return;
      }
      this.$nextTick(function () {
        try {
          let refName = 'editCell' + editCellId;
          this.forceFocusEditCell(refName, true)
          if (forAddDir) {
            document.getElementsByClassName('el-table__body-wrapper ')[0].scrollTop = 0
          }
        } catch (e) {
          console.error(e)
        }
      });
    },
    forceFocusEditCell(refName, selectFlag) {
      try {
        if (typeof (refName) == "undefined" || refName == null) {
          refName = 'editCell' + this.editCellId;
        }
        if (typeof (selectFlag) == "undefined" || selectFlag == null) {
          selectFlag = false
        }
        if (typeof (this.$refs[refName]) != "undefined" && this.$refs[refName] != null) {
          if (typeof (this.$refs[refName].focus) != "undefined") {
            if (selectFlag) {
              this.$refs[refName].select();
            }
            this.$refs[refName].focus();
          }
        }
      } catch (e) {
        console.error(e)
      }
      return true;
    },
    fetchRowKey(row, index) {
      if (typeof (row.id) != 'undefined' && row.id != 0) {
        return row.id;
      }
      return index;
    },
    handleCellInput(e) {
      // console.log('handleCellInput e.data=', e.data, 'selectionStart', e.target.selectionStart, 'selectionEnd',  e.target.selectionEnd, ' editCellVal = ', this.editCellVal, new Date())
      this.editCellFocus = true
      if (typeof (e) != "undefined" && typeof (e.data) != "undefined" && e.data != '') {
        const selectionStart = typeof (e.target) != "undefined" ? e.target.selectionStart : -1;
        const selectionEnd = typeof (e.target) != "undefined" ? e.target.selectionEnd : -1;
        if (!this.validateFileName(e.data)) {
          this.editCellVal = fmtInvalidFileName(this.editCellVal.trim())
          this.delayHideCellErrorTip()
          this.$nextTick(function () {
            if (typeof (selectionStart) != "undefined" && selectionStart > 0) {
              e.target.selectionStart = selectionStart - 1
              e.target.selectionEnd = selectionEnd - 1
            }
          })
        }
      }
    },
    delayHideCellErrorTip() {
      if (this.editCellToolTipTimer) {
        window.clearTimeout(this.editCellToolTipTimer)
      }
      let vm = this;
      this.editCellToolTipTimer = setTimeout(function () {
        vm.validateFileName(vm.editCellVal)
        // console.log('editCellErrorTip', vm.editCellErrorTip, new Date())
      }, 3000)
    },
    handleCellInputKeyDown(e, index, row) {
      if (e.which == 13) {
        // console.log('handleCellInputKeyDown', e.key, e.which , ' row.id =', row.id, ' rowIndex =', index, new Date())
        this.handleCellInputEvent(e, index, row)
      }
    },
    handleCellInputFocus(e) {
      // console.log('handleCellInputFocus', e.data, new Date())
      this.editCellFocus = true
      this.editCellToolTipVisible = this.editCellFocus && this.editCellErrorTip != ''
      e.currentTarget.select()
    },
    handleCellInputBlur(e, index, row) {
      this.editCellFocus = false
      this.editCellToolTipVisible = false
      this.handleCellInputEvent(e, index, row)
    },
    validateCancelEditModeEvent(event) {
      try {
        if (typeof (event.relatedTarget) != "undefined" && event.relatedTarget != null) {
          if (typeof (event.relatedTarget.className) != "undefined" && event.relatedTarget.nodeName == 'BUTTON') {
            const _className = event.relatedTarget.className
            if (_className != null && _className.indexOf('custom-icon-button') != -1) {
              return true;
            }
          }
        }
      } catch (e) {
        console.error(e, new Date())
      }
      return false;
    },
    handleCellInputEvent(event, index, row, doSubmit) {
      try {
        if (typeof (doSubmit) == "undefined") {
          doSubmit = true;
        }
        if (typeof (row.id) != 'undefined' && row.id != this.editCellId) {
          return;
        }
        let refName = 'editCell' + this.fetchRowKey(row, index);
        if (this.validateCancelEditModeEvent(event)) {
          return;
        }
        //  console.log('handleCellInputBlur',event , index, row,  refName, this.editCellVal, new Date())
        this.editCellVal = this.editCellVal.trim()
        if (this.editCellVal.length == 0) {
          if (doSubmit) {
            this.$message.error(row.isDir == 1 ? '文件夹名称不能为空' : '文件名称不能为空');
            this.editCellVal = this.editCellOldItem.name
            this.forceFocusEditCell(refName)
          }
          return;
        }
        if (!this.validateFileName(this.editCellVal)) {
          // this.forceFocusEditCell(refName)
          return;
        }

        if (doSubmit) {
          try {
            if (typeof (row.id) != 'undefined') {
              if (row.id > 0) {
                this.editName(row.id, this.editCellVal, row, index);
              }
            }
            // row.name = this.editCellVal;
          } catch (t1) {
            console.error(t1, new Date())
          }
        }
      } finally {
        this.editCellToolTipVisible = this.editCellFocus && this.editCellErrorTip != ''
      }
    },
    afterAddDir() {
      this.addDirOptItem = {id: 0, st: 0}
      this.quitEditCellMode(0)
    },
    cancelEditMode() {
      // console.log('cancelEidtMode', new Date())
      this.addDirOptItem = {id: 0, st: 0}
      this.quitEditCellMode()
      this.refreshFiles()
    },
    quitEditCellMode(index) {
      try {
        // console.log('quitEditCellMode', index, new Date())
        if (typeof (index) == "undefined" && this.editCellId != -1) {
          index = this.fetchRowIndex(this.editCellId)
        }
        this.editCellId = -1;
        this.editCellVal = '';
        this.editCellErrorTip = '';
        // this.editCellRowItem={id:0, name:''};
        this.resetResEditModeType()
        this.resetTrDraggable(index, true)
      } catch (e) {
        console.error(e, new Date())
      }
    },
    fetchRowIndex(id) {
      try {
        if (typeof (id) == "undefined" || id <= 0 || this.fileData.length == 0) {
          return -1;
        }
        for (let i = 0; i < this.fileData.length; i++) {
          let item = this.fileData[i]
          if (item.id == id) {
            return i;
          }
        }
      } catch (e) {
        console.error(e)
      }
      return -1
    },
    validateFileName(name) {
      let errorTip = '';
      try {
        if (name != null && name.length > 0) {
          if (!validateFileName(name)) {
            errorTip = '文件名不能包含下列任何字符：/ \\ ： * ？" < > |'
          } else if (name.length > 198) {
            errorTip = "字符上限最大支持≤198";
          }
        }
      } catch (t) {
        console.error(t, new Date())
      } finally {
        this.editCellErrorTip = errorTip;
      }
      return errorTip == '';
    },
    getMultipleSelectionIds() {
      let ids = []
      try {
        if (this.multipleSelection != null) {
          let key = this.recycleType ? 'fileId' : 'id'
          this.multipleSelection.forEach(row => {
            ids.push(row[key])
          });
        }
      } catch (e) {
        console.error(e, new Date())
      }
      return ids;
    },
    handleCurrentChange(row) {
      // console.log('handleCurrentChange id=', row.id, this.multipleSelection.length,row.id in this.multipleSelectionCache, new Date())
      this.currentRow = row;
    },
    rowClick(row, column) {
      try {
        // console.log('rowClick', row, 'column.type', column.type, new Date())
        if (typeof (column.type) != "undefined" && column.type == "selection") {
          this.$refs.resTable.toggleRowSelection(row);
          return;
        }
        if (this.multipleSelection.length == 0) {
          this.$refs.resTable.toggleRowSelection(row);
        } else {
          if (this.multipleSelection.length == 1) {
            if (row.id in this.multipleSelectionCache) {
              this.$refs.resTable.toggleRowSelection(row);
            } else {
              this.toggleSelection(row)
              this.$refs.resTable.toggleRowSelection(row);
            }
          } else {
            if (row.id in this.multipleSelectionCache) {
              this.toggleSelection(row)
            } else {
              this.toggleSelection(row)
              this.$refs.resTable.toggleRowSelection(row);
            }
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    handleSelectionChange(rows) {
      // console.log('handleSelectionChange', rows, new Date())
      try {
        this.multipleSelection = rows;
        let tmpMap = {};
        rows.forEach((r, i) => {
          if (r && r.id > 0) {
            tmpMap[r.id] = {id: r.id, index: i}
          }
        });
        this.multipleSelectionCache = tmpMap

        let type = rows.length > 1 ? 2 : (rows.length == 1 ? 1 : 0);
        this.changeResEditModeType(type)
      } catch (e) {
        console.error(e)
      }
    },
    tableRowClassName({row}) {
      if (row.id in this.multipleSelectionCache) {
        return 'highlight-row-color'
      }
      return '';
    },
    toggleSelection(currentRow) {
      // this.$refs.resTable.clearSelection();
      if (this.multipleSelection) {
        this.multipleSelection.forEach(row => {
          if (currentRow.id != row.id) {
            this.$refs.resTable.toggleRowSelection(row, false);
          }
        });
      }
    },
    tableHeaderCellClassName({rowIndex, columnIndex}) {
      if (rowIndex == 0) {
        if (columnIndex == 1) {
          return 'th_column_name';
        } else if (columnIndex > 1) {
          return 'with-left-border';
        }
      }
      return '';
    },
    resetRowLastModifiedDate(row) {
      try {
        if (typeof (row) != "undefined" && row != null) {
          const now = new Date().getTime();
          row.lastModifiedDate = now
          row.lastModifiedDateStr = formatStrDotyyyyMMddhhmm(now)
        }
      } catch (e) {
        console.error(e, new Date())
      }
    },
    formatLastModifiedDate(item) {
      if (typeof (item.lastModifiedDateStr) != "undefined" && item.lastModifiedDateStr != null) {
        return item.lastModifiedDateStr;
      }
      // console.log('formatLastModifiedDate item.updatetimeValue', item.name, item.updatetimeValue, 'lastModifiedDate', item.lastModifiedDate)
      let lastModifiedDateStr = '';
      if (typeof (item.lastModifiedDate) != "undefined" && item.lastModifiedDate != null) {
        lastModifiedDateStr = formatStrDotyyyyMMddhhmm(item.lastModifiedDate);
      } else if (typeof (item.updatetimeValue) != "undefined" && item.updatetimeValue != 0) {
        lastModifiedDateStr = formatStrDotyyyyMMddhhmm(item.updatetimeValue);
      }
      item.lastModifiedDateStr = lastModifiedDateStr;
      return lastModifiedDateStr;
    },
    formatDateTime(dateTime) {
      // console.log('typeof(dateTime)', dateTime, new Date())
      if (typeof (dateTime) != "undefined" && dateTime != '') {
        return formatStrDotyyyyMMddhhmm(dateTime);
      }
      return '';
    },
    fmtFileSize(fileSize) {
      if (typeof (fileSize) != "undefined" && fileSize != '-') {
        return formatFileSize(fileSize, 2);
      }
      return '-';
    },
    fmtFileTypeLabel(row) {
      if (typeof (row.fileTypeLabel) != "undefined" && row.fileTypeLabel != null) {
        return row.fileTypeLabel;
      }
      row.fileTypeLabel = fetchFileTypeLabelByItem(row);
      return row.fileTypeLabel;
    },
    fmtFileFullName(row) {
      if (typeof (row.fileFullName) != "undefined" && row.fileFullName != null) {
        return row.fileFullName;
      }
      row.fileFullName = fmtFileFullName(row);
      return row.fileFullName;
    },
    fmtFileIcon(row) {
      let icon = typeof (row.fileTypeIcon) != "undefined" ? row.fileIcon : (row.fileIcon = fetchFileTypeIcon(row.fileType));
      if (icon != '') {
        return '<svg class="icon" aria-hidden="true"><use xlink:href="#' + icon + '"></use></svg>';
      }
      return '';
    },
    previewFile(row) {
      this.$emit('previewFile', row)
    },
    pcDownload(row) {
      this.download([row.id], row.isDir ? row.name + '.zip' : fmtFileFullName(row))
    },
  }
}
